import { useDrawer } from '../context/DrawerProvider';
import { useCallback } from 'react';
import { UserRow } from '../components/UsersTable/types';
import { DeviceToken } from '../types/User';
import UserDrawerContent, { UserDrawerContentLoader } from '../components/UserDrawerContent';
import { useUsers } from '../context/UserManagementContext';

export const useUserDrawer = () => {
    const { openDrawer, closeDrawer } = useDrawer();
    const { users, mutate, userSession, fetchProtectedEntities, systemData } = useUsers();

    const handleUserUpdated = useCallback(() => {
        mutate();
        fetchProtectedEntities();
    }, [mutate, fetchProtectedEntities]);

    const openUserDrawer = useCallback(
        (userId: UserRow['id'], tokenToFocus?: DeviceToken['id']) => {
            const user = users.find((user) => user.guid === userId);

            if (user && userSession) {
                openDrawer({
                    className: 'min-w-[720px]',
                    contentClassName: '[&]:p-0 max-w-[720px] overflow-x-none',
                    headerTitle: 'Manage User',
                    onClose: closeDrawer,
                    DrawerContent: (
                        <UserDrawerContent
                            user={user}
                            userSession={userSession}
                            tokenToFocus={tokenToFocus}
                            onClose={closeDrawer}
                            onUserUpdated={handleUserUpdated}
                            systemData={systemData}
                        />
                    ),
                    DrawerContentPlaceholder: <UserDrawerContentLoader />
                });
            }
        },
        [users, userSession, openDrawer, closeDrawer, handleUserUpdated]
    );

    return { openUserDrawer };
};
